import type { LazyModule } from "owa-bundling";
import { LazyAction } from "owa-bundling";

export type TModule<TLazyModule> = TLazyModule extends LazyModule<infer M> ? M : never;

export type AsyncFunction<TFunc extends (...args: any) => any> = (...params: Parameters<TFunc>) => Promise<ReturnType<TFunc>>;

export default function wrapLazy<TLazyModule extends LazyModule<any>, TName extends keyof TModule<TLazyModule>>(lazyModule: TLazyModule, name: TName): AsyncFunction<TModule<TLazyModule>[TName]> {
    // eslint-disable-next-line owa-custom-rules/require-lazy-import-passthrough-types -- The typing is done on the outer function
    const lazyAction = new LazyAction(lazyModule, m => m[name]);
    
    return (...args: Parameters<(typeof lazyAction)["importAndExecute"]>): ReturnType<(typeof lazyAction)["importAndExecute"]> => {
        return lazyAction.importAndExecute(...args);
    };
}
